(function(){
  if(window.__memPdp) return; window.__memPdp=true;
  var d=document; d.documentElement.classList.add('mem-js');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function target(){
    return d.getElementById('mem-buy')||d.querySelector('.product__info-container .shopify-app-block')||d.querySelector('.product__info-container');
  }
  function goBuy(e){
    var t=target(); if(!t) return; if(e) e.preventDefault();
    var h=d.querySelector('sticky-header,.section-header'),off=(h?h.getBoundingClientRect().height:90)+20;var top=t.getBoundingClientRect().top+window.pageYOffset-off;
    window.scrollTo({top:top,behavior:reduce?'auto':'smooth'});
    setTimeout(function(){var f=t.parentElement&&t.parentElement.querySelector('button,input,[tabindex]'); if(f&&f.focus) try{f.focus({preventScroll:true})}catch(_){}} ,reduce?0:600);
  }
  d.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[data-mem-buy]'); if(a) goBuy(e);});
  function init(){
    // Tabs
    d.querySelectorAll('[data-mem-tabs]').forEach(function(root){
      var tabs=[].slice.call(root.querySelectorAll('[role=tab]'));
      function sel(tab){tabs.forEach(function(t){var on=t===tab;t.setAttribute('aria-selected',on);t.tabIndex=on?0:-1;var p=d.getElementById(t.getAttribute('aria-controls')); if(p) p.hidden=!on;});}
      tabs.forEach(function(t,i){
        t.addEventListener('click',function(){sel(t)});
        t.addEventListener('keydown',function(e){var n=null; if(e.key==='ArrowRight')n=tabs[(i+1)%tabs.length]; if(e.key==='ArrowLeft')n=tabs[(i-1+tabs.length)%tabs.length]; if(n){e.preventDefault();sel(n);n.focus();}});
      });
    });
    // Film
    d.querySelectorAll('[data-mem-film]').forEach(function(f){
      var v=f.querySelector('video'),b=f.querySelector('[data-mem-film-toggle]'); if(!v||!b) return;
      function label(){var p=v.paused;b.textContent=p?'Play film':'Pause film';b.setAttribute('aria-pressed',p?'true':'false');}
      if(reduce){v.removeAttribute('autoplay');v.pause();}
      b.addEventListener('click',function(){v.paused?v.play():v.pause();});
      v.addEventListener('play',label);v.addEventListener('pause',label);label();
    });
    // Sticky dock: show after the buy box scrolls away, hide when the buy form or footer is visible
    var dock=d.querySelector('[data-mem-dock]'), form=d.querySelector('.product__info-container product-form, .product__info-container .product-form')||target();
    if(dock&&form&&'IntersectionObserver' in window){
      var formVisible=true, past=false;
      function upd(){var show=!formVisible&&past; dock.classList.toggle('is-visible',show); dock.setAttribute('aria-hidden',show?'false':'true'); var a=dock.querySelector('a'); if(a) a.tabIndex=show?0:-1;}
      new IntersectionObserver(function(es){es.forEach(function(e){formVisible=e.isIntersecting; past=e.boundingClientRect.top<0||past&&!e.isIntersecting; if(e.isIntersecting) past=false; if(!e.isIntersecting&&e.boundingClientRect.top<0) past=true; upd();});},{threshold:0}).observe(form);
    }
    // Reveal
    if(!reduce&&'IntersectionObserver' in window){
      var els=d.querySelectorAll('.mem-section .mem-wrap>*, .mem-gift .mem-wrap, .mem-closing .mem-wrap');
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
      els.forEach(function(el){el.classList.add('mem-reveal');io.observe(el);});
    }
  }
  if(d.readyState==='loading') d.addEventListener('DOMContentLoaded',init); else init();
})();
;(function(){
  if(window.__memOpt)return;window.__memOpt=1;
  var d=document;
  function vs(){return d.querySelector('.product__info-container variant-selects, variant-selects')}
  function groups(){var v=vs();return v?[].slice.call(v.querySelectorAll('fieldset, .product-form__input--dropdown')):[]}
  function current(){return groups().map(function(g){var r=g.querySelector('input[type=radio]:checked');if(r)return r.value;var s=g.querySelector('select');return s?s.value:null})}
  function data(el){try{return JSON.parse(el.querySelector('[data-mem-variants]').textContent)}catch(e){return[]}}
  function sync(){
    var cur=current();
    d.querySelectorAll('[data-mem-option]').forEach(function(b){
      var i=+b.getAttribute('data-mem-option')-1, vars=data(b);
      b.querySelectorAll('.mem-card').forEach(function(c){
        var v=c.getAttribute('data-value'), on=cur[i]===v;
        c.classList.toggle('is-selected',on);c.setAttribute('aria-checked',on?'true':'false');
        if(!c.hasAttribute('data-auto-img'))return;
        var im=c.querySelector('img');if(!im)return;
        var best=null;
        vars.forEach(function(x){if(x.o[i]!==v||!x.img)return;var ok=x.o.every(function(val,k){return k===i||cur[k]==null||cur[k]===val});if(ok&&!best)best=x.img});
        if(!best)vars.some(function(x){if(x.o[i]===v&&x.img){best=x.img;return true}});
        if(best&&im.getAttribute('src')!==best)im.setAttribute('src',best);
      });
    });
  }
  function choose(i,v){
    var g=groups()[i];if(!g)return;
    var r=[].slice.call(g.querySelectorAll('input[type=radio]')).filter(function(x){return x.value===v})[0];
    if(r){if(!r.checked){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}}
    else{var s=g.querySelector('select');if(s){s.value=v;s.dispatchEvent(new Event('change',{bubbles:true}))}}
    setTimeout(sync,30);setTimeout(sync,600);setTimeout(sync,1500);
  }
  d.addEventListener('click',function(e){var c=e.target.closest&&e.target.closest('.mem-card');if(!c)return;var b=c.closest('[data-mem-option]');choose(+b.getAttribute('data-mem-option')-1,c.getAttribute('data-value'))});
  d.addEventListener('change',function(e){if(e.target.closest&&e.target.closest('variant-selects'))setTimeout(sync,30)});
  function place(){
    d.querySelectorAll('[data-mem-move]').forEach(function(b){
      var btns=d.querySelector('.product__info-container product-form .product-form__buttons')||d.querySelector('.product__info-container .product-form__buttons');if(!btns)return;
      var g=btns.querySelector('.gpo-container');
      if(g){if(g.nextElementSibling!==b)g.parentNode.insertBefore(b,g.nextSibling)}
      else if(b.nextElementSibling!==btns||b.parentNode!==btns.parentNode)btns.parentNode.insertBefore(b,btns);
    });
  }
  function init(){sync();place();var n=0,t=setInterval(function(){place();if(++n>30)clearInterval(t)},400);
    var info=d.querySelector('.product__info-container');if(info&&window.MutationObserver)new MutationObserver(function(){clearTimeout(init._t);init._t=setTimeout(sync,80)}).observe(info,{childList:true,subtree:true});}
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
  d.addEventListener('shopify:section:load',init);
})();

;(function(){
  /* Keep visible Globo option fields (gift note, engraving) typeable.
     Uploadly's "photo required" lock disables every field in the product form
     until both photos are uploaded; this re-enables only visible GPO text fields
     and leaves fields hidden by Globo conditional logic untouched. */
  if(window.__memGpoFix)return;window.__memGpoFix=1;
  var d=document,SEL='.gpo-app .gpo-element textarea[disabled], .gpo-app .gpo-element input[disabled]:not([type=hidden]):not([type=radio]):not([type=checkbox]):not([type=file])';
  function fix(){
    d.querySelectorAll(SEL).forEach(function(el){
      if(!el.closest('.product__info-container, product-form, form[action*="/cart/add"]'))return;
      if(el.hasAttribute('data-unavailable'))return;
      var g=el.closest('.gpo-element');
      if(!g||g.offsetParent===null)return;
      el.disabled=false;
    });
  }
  function init(){
    fix();
    if(window.MutationObserver&&!init._o){
      init._o=new MutationObserver(function(){clearTimeout(init._t);init._t=setTimeout(fix,0)});
      init._o.observe(d.body,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','style','class']});
    }
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
  d.addEventListener('shopify:section:load',fix);
})();
